import { LANGUAGES } from '../model/form.model'; 
import { invert } from 'lodash';

class BannerImagePreviewFactory {
  constructor(MarketingApiService) {
    'ngInject';

    this.MarketingApiService = MarketingApiService;

    this.MarketingApiService.getImagesList().then(list => this.imagesList = list);
  }

  preview(filename) {
    return this.MarketingApiService.previewBanner(filename);
  }

  getPreviewableBanner(form) {
    return this.inferFileName(form);
  }

  inferFileName(form) {;
    let language = form.language;
    const image = this.imagesList.filter((image) => {
      if (image.type_text === form.type && image.language === language && image.dimension === form.size) {
        return image;
      }
    })[0];

    return image.filename;
  }
}

export default BannerImagePreviewFactory;



// WEBPACK FOOTER //
// ./client/app/pages/marketing/factory/bannerimagepreview.factory.js